import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'routing-groups-search',
  templateUrl: './routing-groups-search.component.html',
  styleUrls: ['./routing-groups-search.component.scss']
})
export class RoutingGroupsSearchComponent implements OnInit {

  onApply = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<RoutingGroupsSearchComponent>,
              @Inject(MAT_DIALOG_DATA) public search: any) {
  }

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close();
    this.onApply.emit(this.search);
  }
}
